import { FixedDatum } from '../';
import { convertToDatum } from '../../Util';
import Vue from 'vue';

const Observer = (new Vue()).$data.__ob__.constructor;


/**
 * 
 */
export class FixedSeries extends Array {
  /**
   * Initialize a TimeSeries from an input Array
   * 
   * @param {Number} input Array of Datum or Datum-compatible value pairs
   */
  constructor(value) {
    super();
    this.createObserver(); // Hack to avoid Vue destroying the class
    
    this.push(value);
  }

  createObserver() {
    // Split into a separate function for easy unit test mocking
    this.__ob__ = new Observer({});
  }


  /**
   * Push Datum-compatible elements into the TimeSeries
   * 
   * @param  {Number} inputArray List of items to add to the TimeSeries
   */
  push(value) {
    let datum = convertToDatum(value);

    if (datum instanceof FixedDatum) {
      if (this.length > 0) {
        super.pop();
      }
      super.push(datum);
    } else {
      throw Error('FixedSeries input must be a number');
    }
  }


  /** Return an array of all the TimeSeries dates */
  getIndices() { return Array.from(this).map(v => v.index); }

  /** Return an array of all the TimeSeries values */
  getValues() { return Array.from(this).map(v => v.value);  }
  
  /** Return an array with [index, value] pair items */
  getPairs() { return Array.from(this).map(v => [v.index, v.value]); }
}